import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-inner">
        <a href="#hero" className="logo" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}>
          <span>ANLAR</span>
          <span className="logo-divider" />
          <span className="logo-sub">OTO<br/>DIZAYN</span>
        </a>
        <nav className="nav-links">
          <button className="nav-link" onClick={() => scrollTo('hizmetler')}>Hizmetlerimiz</button>
          <button className="nav-link" onClick={() => scrollTo('hakkimizda')}>Hakkımızda</button>
          <button className="nav-link" onClick={() => scrollTo('iletisim')}>İletişim</button>
        </nav>
        <div className="header-actions">
          <a href="tel:+905544356351" className="phone-icon-btn" aria-label="Telefon">
            <Phone size={18} />
          </a>
          <a href="#iletisim" className="btn-primary" onClick={(e) => { e.preventDefault(); scrollTo('iletisim'); }}>
            Randevu Al
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
